/*
  ЗАЯВКАТА И «УВЕДОМИ МЕ» — поведението на формата.

  Изнесено от blocks/buy-buttons.liquid на 08.10 БЕЗ НИТО ЕДНА ПРОМЯНА по кода:
  беше два вградени <script> блока, всеки чист JavaScript без Liquid.

  Причината да излезе: слушателите са ДЕЛЕГИРАНИ на документа, тоест обслужват
  всяка форма `[data-gm-notify]` на страницата, където и да е тя. Докато кодът
  живееше в блока на бутоните, той стигаше само до страницата на плочата —
  затова карта в решетка не можеше да отвори заявка. Сега файлът се зарежда от
  layout/theme.liquid и формата работи и от карта.

  Пази се зад window.gmNotifyReady: при два екземпляра на страницата
  слушателите не се закачат два пъти.
*/
if (!window.gmNotifyReady) {
    window.gmNotifyReady = true;

    const facts = (box) => {
      const store = box.querySelector('[data-gm-notify-variants]');
      if (!store) return {};
      try {
        return JSON.parse(store.textContent);
      } catch (error) {
        return {};
      }
    };

    const current = (box) => facts(box)[String(box.dataset.gmVariantId)] || {};

    // Изборът на състояние минава без презареждане. Блокът се показва само
    // когато ИЗБРАНИЯТ вариант е изчерпан — при смесена плоча наличният си
    // запазва «Добави в кошницата».
    const sync = (box) => {
      // Предварителната поръчка е НАЛИЧНА за Shopify и въпреки това се заявява:
      // блокът ѝ е единственото действие и не се крие при смяна на вариант.
      if (box.dataset.gmAlways === 'true') {
        box.dataset.gmVisible = 'true';
        return;
      }
      const row = current(box);
      const sold = row.available === false;
      box.dataset.gmVisible = sold ? 'true' : 'false';
      if (!sold) return;
      const label = box.querySelector('[data-gm-notify-condition]');
      if (label) label.textContent = row.title && row.title !== 'Default Title' ? row.title : '';
    };

    document.addEventListener('click', (event) => {
      const open = event.target.closest('[data-gm-notify-open]');
      if (open) {
        const box = open.closest('[data-gm-notify]');
        box.querySelector('[data-gm-notify-modal]').showModal();
        // Само «уведоми ме» тръгва с отварянето. Заявката от доставчик е
        // ангажимент и се потвърждава с натискане — дори когато пощата е знайна.
        if (box.dataset.gmEmail && box.dataset.gmAsk !== 'request') {
          send(box, box.dataset.gmEmail);
        } else {
          const field = box.querySelector('[data-gm-notify-input]');
          if (field) field.focus();
        }
        return;
      }

      const close = event.target.closest('[data-gm-notify-close]');
      if (close) {
        close.closest('[data-gm-notify-modal]').close();
        return;
      }

      const submit = event.target.closest('[data-gm-notify-submit]');
      if (submit) {
        const box = submit.closest('[data-gm-notify]');
        send(box, (box.querySelector('[data-gm-notify-input]').value || '').trim());
      }
    });

    // Натискане върху затъмнението затваря прозореца: <dialog> брои това за клик
    // по себе си, защото фонът е негов, не отделен елемент.
    document.addEventListener('click', (event) => {
      const modal = event.target.closest('[data-gm-notify-modal]');
      if (!modal || event.target !== modal) return;
      modal.close();
    });

    // Enter в полето минава по същия път като бутона — една пътека, една логика.
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      const input = event.target.closest('[data-gm-notify-input]');
      if (!input) return;
      event.preventDefault();
      const button = input.closest('[data-gm-notify]').querySelector('[data-gm-notify-submit]');
      if (button) button.click();
    });

    async function send(box, email) {
      if (!box || box.dataset.gmBusy === 'true') return;

      const form = box.querySelector('[data-gm-notify-form]');
      const note = box.querySelector('[data-gm-notify-note]');
      const button = box.querySelector('[data-gm-notify-submit]');
      const error = box.querySelector('[data-gm-notify-error]');
      const done = box.querySelector('[data-gm-notify-done]');
      const doneText = box.querySelector('[data-gm-notify-done-text]');

      const fail = (text) => {
        error.textContent = text;
        error.hidden = false;
        box.dataset.gmState = 'error';
        const input = box.querySelector('[data-gm-notify-input]');
        if (input) input.focus();
      };

      // Успехът заменя полето и бутона: няма какво повече да се прави тук.
      const finish = (text) => {
        doneText.textContent = text;
        done.hidden = false;
        error.hidden = true;
        if (form) form.hidden = true;
        if (note) note.hidden = true;
        box.dataset.gmState = 'done';
      };

      // Поръчката иска име; другите две форми нямат такова поле и подминават.
      const nameField = box.querySelector('[data-gm-notify-name]');
      const person = nameField ? (nameField.value || '').trim() : '';
      if (nameField && !person) {
        fail(box.dataset.gmMessageName);
        nameField.focus();
        return;
      }

      if (!email) {
        fail(box.dataset.gmMessageEmpty);
        return;
      }

      // Имейл или телефон — кое от двете, се познава от съдържанието, не от
      // второ поле. Маймунското «а» решава: има ли го, проверява се като адрес;
      // няма ли го, остават цифрите. Разделители, скоби и водещо «+» се махат,
      // защото хората пишат номера както им дойде: 0886 699 339, +359 88 …
      const isMail = email.includes('@');
      const digits = email.replace(/[^\d]/g, '');
      const mailOk = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);
      const phoneOk = digits.length >= 8 && digits.length <= 15;
      if (nameField && !(isMail ? mailOk : phoneOk)) {
        fail(box.dataset.gmMessageContact);
        return;
      }

      error.hidden = true;
      box.dataset.gmBusy = 'true';
      box.dataset.gmState = 'sending';
      if (button) {
        button.disabled = true;
        button.textContent = button.dataset.gmLabelSending;
      }

      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const row = current(box);

      // Две точки, един прозорец. «Уведоми ме» записва чакащ за ПЛОЧАТА (и за
      // състоянието, ако има SKU); заявката отива при същата точка, която
      // обслужва и каталожната страница, с бележка вместо SKU — там няма
      // състояние, което да се избира.
      const ask = box.dataset.gmAsk === 'request';

      try {
        const response = await fetch(
          root + (ask ? 'apps/gramofonika/catalog-request' : 'apps/gramofonika/notify-me'),
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(
              ask
                ? {
                    // Телефонът НЕ влиза в полето за поща: ERP пази двете
                    // отделно и прави самоличността от тях (пощата, иначе
                    // номерът в канонична форма). Написаното се пази както го е
                    // дал човекът — «088 6699339» и «+359 88 6699339» са един
                    // и същ човек за индекса, но на екрана стои неговият запис.
                    email: isMail ? email : '',
                    phone: isMail ? '' : email,
                    name: person,
                    // Кой вид заявка е. Липсващо значи «catalog» и от страна на
                    // ERP, тоест каталожната форма не се променя от това.
                    kind: box.dataset.gmKind || 'catalog',
                    handle: box.dataset.gmHandle,
                    // Името и контактът СА отделни полета в ERP от 28.09, но
                    // остават и тук: бележката се чете от човек и застрахова
                    // случая, в който някое от полетата не стигне. ERP:
                    // «остави го или го махни, все тая».
                    note: [box.dataset.gmNote || '', person, email]
                      .filter(Boolean)
                      .join(' · '),
                  }
                : {
                    email: email,
                    handle: box.dataset.gmHandle,
                    product_id: box.dataset.gmProductId,
                    // Без SKU заявката се записва за цялата плоча; с него — за
                    // точното състояние, което човекът е избрал на екрана.
                    sku: row.sku || '',
                  }
            ),
          }
        );

        const data = await response.json().catch(() => ({}));

        if (response.ok && data.success) {
          // ERP връща човешкото име на състоянието, разчетено от SKU-то. Има ли
          // го, потвърждението казва точно какво е поискано — «щом влезе M- / VG+»,
          // не «щом плочата се върне». Обещанието е за състоянието.
          const key = data.condition
            ? (data.already ? 'gmMessageAlreadyCondition' : 'gmMessageSuccessCondition')
            : (data.already ? 'gmMessageAlready' : 'gmMessageSuccess');
          finish((box.dataset[key] || '').replace('[state]', data.condition || ''));
          return;
        }

        fail(data.detail || box.dataset.gmMessageError);
      } catch (err) {
        fail(box.dataset.gmMessageError);
      } finally {
        box.dataset.gmBusy = 'false';
        if (button) {
          button.disabled = false;
          button.textContent = button.dataset.gmLabelIdle;
        }
      }
    }

    const watch = () => {
      document.querySelectorAll('[data-gm-notify]').forEach((box) => {
        const section = box.closest('[id*="ProductInformation-"]') || document;
        section.addEventListener('shopify:product:select', (event) => {
          const use = (detail) => {
            const id = detail && detail.resource && detail.resource.id;
            if (!id) return;
            box.dataset.gmVariantId = String(id);
            sync(box);
          };
          if (event.promise && typeof event.promise.then === 'function') {
            event.promise.then((result) => use(result && result.detail)).catch(() => {});
          } else {
            use(event.detail);
          }
        });
        sync(box);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', watch, { once: true });
    } else {
      watch();
    }
  }


  if (!window.gmBuyNowReady) {
    window.gmBuyNowReady = true;

    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-gm-buy-now]');
      if (!button || button.disabled) return;

      const form = button.closest('form');
      if (!form) return;

      event.preventDefault();
      button.setAttribute('aria-busy', 'true');

      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      try {
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        });
        if (!response.ok) throw new Error(response.status);
        window.location.href = root + 'checkout';
      } catch (error) {
        button.removeAttribute('aria-busy');
      }
    });
  }
